var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcMoreInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.00081 8.80023V6.40023M8.00081 4.00023V4.06039M7.7914 11.061L4.45227 14.4001V11.061H3.2001C2.31644 11.061 1.6001 10.3446 1.6001 9.46097V3.2001C1.6001 2.31644 2.31644 1.6001 3.2001 1.6001H12.8001C13.6838 1.6001 14.4001 2.31644 14.4001 3.2001V9.46096C14.4001 10.3446 13.6838 11.061 12.8001 11.061H7.7914Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcMoreInfo);
export default __webpack_public_path__ + "static/media/ic-more-info.467d19dd66f3421e36d7346d287f2d08.svg";
export { ForwardRef as ReactComponent };